import { EntityPresenterMode, isStaticMode } from './presenterEntityMode';

import type { Maybe } from '@nova/core';
import type { PresenterPlaceholderData } from './presenterPlaceholder';
import type { YardAreaDetails } from './useYardAreaPresenter';
import type { YardSpotDetails } from './yardSpotPresenterShared';

export function nestedSpotPresenterDataProps(
  mode: EntityPresenterMode,
  data: {
    spot?: Maybe<YardSpotDetails | PresenterPlaceholderData<YardSpotDetails>>;
    spotArea?: Maybe<YardAreaDetails | PresenterPlaceholderData<YardAreaDetails>>;
  }
) {
  if (isStaticMode(mode)) {
    return {
      staticSpotData: (data.spot ?? null) as Maybe<YardSpotDetails>,
      staticAreaData: (data.spotArea ?? null) as Maybe<YardAreaDetails>
    };
  }

  return {
    placeholderSpotData: (data.spot ?? null) as Maybe<PresenterPlaceholderData<YardSpotDetails>>,
    placeholderAreaData: (data.spotArea ?? null) as Maybe<PresenterPlaceholderData<YardAreaDetails>>
  };
}
